jQuery.feature_import("js-store-field",
  () => require("./store-field.js"),
  mod => mod.feature_js_store_field
);